import { useCallback, useEffect, useMemo, useState } from "react";
import { QuestProvider, GetStarted as QGetStarted } from "@questlabs/react-sdk";
import Cookies from "universal-cookie";
import Modal from "../../../ui/Modal/Modal";
import "./GetStarted.scss";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "../../../ui/Icon/Icon";
import RadialProgressBar from "../../../ui/RadialProgressBar/RadialProgressBar";

const TickIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http:www.w3.org/2000/svg"
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_5282_647)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="white"
      />
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#FF665C"
      />
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#FF665C"
      />
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#FF665C"
      />
      <path
        d="M48.4164 79.0566C49.1835 78.9079 49.9461 78.7367 50.7031 78.5433C51.9867 78.1845 53.2517 77.7617 54.4931 77.2766C55.7361 76.7956 56.9543 76.2527 58.1431 75.65C59.3322 75.0449 60.4903 74.3807 61.6131 73.66C62.7345 72.939 63.8192 72.1625 64.8631 71.3333C65.9088 70.5029 66.9123 69.6207 67.8698 68.69C68.8257 67.7615 69.7346 66.7858 70.5931 65.7666C71.4523 64.7465 72.26 63.6841 73.0131 62.5833C73.766 61.4844 74.4635 60.3485 75.1031 59.18C75.7427 58.0097 76.3235 56.8082 76.8431 55.58C77.3632 54.3514 77.8216 53.0976 78.2164 51.8233C78.5545 50.7076 78.8437 49.5776 79.0831 48.4366L55.3164 24.6733C53.3093 22.6573 50.9234 21.0581 48.2959 19.9678C45.6684 18.8774 42.8512 18.3174 40.0064 18.32C37.1591 18.3169 34.3393 18.8765 31.709 19.9669C29.0787 21.0572 26.6898 22.6567 24.6798 24.6733C22.6646 26.684 21.0659 29.0724 19.9751 31.7018C18.8842 34.3312 18.3228 37.1499 18.3228 39.9966C18.3228 42.8433 18.8842 45.6621 19.9751 48.2914C21.0659 50.9208 22.6646 53.3093 24.6798 55.32L48.4164 79.0566Z"
        fill="white"
      />
      <path
        d="M48.4164 79.0566C49.1835 78.9079 49.9461 78.7367 50.7031 78.5433C51.9867 78.1845 53.2517 77.7617 54.4931 77.2766C55.7361 76.7956 56.9543 76.2527 58.1431 75.65C59.3322 75.0449 60.4903 74.3807 61.6131 73.66C62.7345 72.939 63.8192 72.1625 64.8631 71.3333C65.9088 70.5029 66.9123 69.6207 67.8698 68.69C68.8257 67.7615 69.7346 66.7858 70.5931 65.7666C71.4523 64.7465 72.26 63.6841 73.0131 62.5833C73.766 61.4844 74.4635 60.3485 75.1031 59.18C75.7427 58.0097 76.3235 56.8082 76.8431 55.58C77.3632 54.3514 77.8216 53.0976 78.2164 51.8233C78.5545 50.7076 78.8437 49.5776 79.0831 48.4366L55.3164 24.6733C53.3093 22.6573 50.9234 21.0581 48.2959 19.9678C45.6684 18.8774 42.8512 18.3174 40.0064 18.32C37.1591 18.3169 34.3393 18.8765 31.709 19.9669C29.0787 21.0572 26.6898 22.6567 24.6798 24.6733C22.6646 26.684 21.0659 29.0724 19.9751 31.7018C18.8842 34.3312 18.3228 37.1499 18.3228 39.9966C18.3228 42.8433 18.8842 45.6621 19.9751 48.2914C21.0659 50.9208 22.6646 53.3093 24.6798 55.32L48.4164 79.0566Z"
        fill="#FF665C"
      />
      <path
        d="M48.4164 79.0566C49.1835 78.9079 49.9461 78.7367 50.7031 78.5433C51.9867 78.1845 53.2517 77.7617 54.4931 77.2766C55.7361 76.7956 56.9543 76.2527 58.1431 75.65C59.3322 75.0449 60.4903 74.3807 61.6131 73.66C62.7345 72.939 63.8192 72.1625 64.8631 71.3333C65.9088 70.5029 66.9123 69.6207 67.8698 68.69C68.8257 67.7615 69.7346 66.7858 70.5931 65.7666C71.4523 64.7465 72.26 63.6841 73.0131 62.5833C73.766 61.4844 74.4635 60.3485 75.1031 59.18C75.7427 58.0097 76.3235 56.8082 76.8431 55.58C77.3632 54.3514 77.8216 53.0976 78.2164 51.8233C78.5545 50.7076 78.8437 49.5776 79.0831 48.4366L55.3164 24.6733C53.3093 22.6573 50.9234 21.0581 48.2959 19.9678C45.6684 18.8774 42.8512 18.3174 40.0064 18.32C37.1591 18.3169 34.3393 18.8765 31.709 19.9669C29.0787 21.0572 26.6898 22.6567 24.6798 24.6733C22.6646 26.684 21.0659 29.0724 19.9751 31.7018C18.8842 34.3312 18.3228 37.1499 18.3228 39.9966C18.3228 42.8433 18.8842 45.6621 19.9751 48.2914C21.0659 50.9208 22.6646 53.3093 24.6798 55.32L48.4164 79.0566Z"
        fill="#FF665C"
      />
      <path
        d="M48.4164 79.0566C49.1835 78.9079 49.9461 78.7367 50.7031 78.5433C51.9867 78.1845 53.2517 77.7617 54.4931 77.2766C55.7361 76.7956 56.9543 76.2527 58.1431 75.65C59.3322 75.0449 60.4903 74.3807 61.6131 73.66C62.7345 72.939 63.8192 72.1625 64.8631 71.3333C65.9088 70.5029 66.9123 69.6207 67.8698 68.69C68.8257 67.7615 69.7346 66.7858 70.5931 65.7666C71.4523 64.7465 72.26 63.6841 73.0131 62.5833C73.766 61.4844 74.4635 60.3485 75.1031 59.18C75.7427 58.0097 76.3235 56.8082 76.8431 55.58C77.3632 54.3514 77.8216 53.0976 78.2164 51.8233C78.5545 50.7076 78.8437 49.5776 79.0831 48.4366L55.3164 24.6733C53.3093 22.6573 50.9234 21.0581 48.2959 19.9678C45.6684 18.8774 42.8512 18.3174 40.0064 18.32C37.1591 18.3169 34.3393 18.8765 31.709 19.9669C29.0787 21.0572 26.6898 22.6567 24.6798 24.6733C22.6646 26.684 21.0659 29.0724 19.9751 31.7018C18.8842 34.3312 18.3228 37.1499 18.3228 39.9966C18.3228 42.8433 18.8842 45.6621 19.9751 48.2914C21.0659 50.9208 22.6646 53.3093 24.6798 55.32L48.4164 79.0566Z"
        fill="#FF665C"
      />
      <path
        d="M40.0035 18.3231C45.5435 18.3231 51.0835 20.4398 55.3235 24.6765C57.3386 26.6872 58.9374 29.0756 60.0282 31.705C61.119 34.3344 61.6805 37.1531 61.6805 39.9998C61.6805 42.8465 61.119 45.6652 60.0282 48.2946C58.9374 50.924 57.3386 53.3124 55.3235 55.3231C53.3128 57.3383 50.9244 58.937 48.295 60.0278C45.6656 61.1187 42.8469 61.6801 40.0002 61.6801C37.1535 61.6801 34.3347 61.1187 31.7053 60.0278C29.0759 58.937 26.6875 57.3383 24.6768 55.3231C22.6617 53.3124 21.063 50.924 19.9721 48.2946C18.8813 45.6652 18.3198 42.8465 18.3198 39.9998C18.3198 37.1531 18.8813 34.3344 19.9721 31.705C21.063 29.0756 22.6617 26.6872 24.6768 24.6765C26.6869 22.6598 29.0758 21.0604 31.706 19.97C34.3363 18.8797 37.1562 18.32 40.0035 18.3231ZM49.8702 33.3298C49.5546 33.36 49.2541 33.4791 49.0035 33.6731L36.8235 42.8065L31.1802 37.1665C29.9568 35.8931 27.5468 38.2998 28.8235 39.5231L35.4902 46.1898C35.7792 46.4631 36.1538 46.628 36.5505 46.6566C36.9473 46.6851 37.3417 46.5756 37.6668 46.3465L51.0002 36.3465C52.1202 35.5298 51.4302 33.3531 50.0435 33.3331C49.9869 33.3302 49.9301 33.3302 49.8735 33.3331L49.8702 33.3298Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5282_647">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const BACKEND_URL = import.meta.env.VITE_QUESTLABS_URL as string;

// Here userId means macaw userid and same for email as well
const GetStarted = ({
  userId,
  emailId,
  className,
}: {
  userId: string;
  emailId?: string;
  className?: string;
}) => {
  const navigate = useNavigate();

  const ApiKey = import.meta.env.VITE_QUESTLABS_API_KEY as string;
  const EntityId = import.meta.env.VITE_QUESTLABS_ENTITY_ID as string;
  const QuestId = import.meta.env.VITE_QUESTLABS_QUEST_ID as string;

  const uniqueUserId = userId;
  const uniqueEmailId = emailId;

  const [isGetStartedOpen, setIsGetStartedOpen] = useState(false);
  const [totalActions, setTotalActions] = useState(0);
  const [completedActions, setCompletedActions] = useState(0);
  const [isAllActionsCompleted, setIsAllActionsCompleted] = useState(false);

  const cookies = useMemo(() => new Cookies(), []);

  const getUserAuth = useCallback(
    async ({
      apiKey,
      entityId,
      uniqueUserId,
      uniqueEmailId,
    }: {
      apiKey: string;
      entityId: string;
      uniqueUserId: string;
      uniqueEmailId?: string;
    }) => {
      try {
        const externalUserId = cookies.get("externalUserId") as
          | string
          | undefined;
        const questUserId = cookies.get("questUserId") as string | undefined;
        const questUserToken = cookies.get("questUserToken") as
          | string
          | undefined;

        if (
          externalUserId &&
          externalUserId === uniqueUserId &&
          questUserId &&
          questUserId !== "undefined" &&
          questUserToken &&
          questUserToken !== "undefined"
        ) {
          return {
            userId: questUserId,
            token: questUserToken,
          };
        }

        if (uniqueUserId) {
          const headers = {
            apiKey,
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          };

          const body = {
            externalUserId: uniqueUserId,
            entityId,
            email: uniqueEmailId || null,
          };

          const response = await fetch(
            `${BACKEND_URL}/api/users/external/login`,
            {
              method: "POST",
              headers,
              body: JSON.stringify(body),
            },
          );

          const { userId: newUserId, token: newToken } =
            (await response.json()) as {
              userId: string;
              token: string;
            };

          if (!newUserId || !newToken) {
            throw new Error("Failed to get user auth");
          }

          const expires = new Date();
          expires.setHours(expires.getHours() + 12);

          cookies.set("externalUserId", uniqueUserId ?? "", {
            path: "/",
            expires,
          });
          cookies.set("questUserId", newUserId ?? "", { path: "/", expires });
          cookies.set("questUserToken", newToken ?? "", { path: "/", expires });

          return {
            userId: newUserId,
            token: newToken,
          };
        }

        return null;
      } catch (error) {
        console.error("Error in getUserAuth:", error);
        return null;
      }
    },
    [cookies],
  );

  const fetchCampaignsData = useCallback(
    async ({
      entityId,
      questId,
      apiKey,
      userAuth,
      variation,
    }: {
      entityId: string;
      questId: string;
      apiKey: string;
      userAuth: { userId: string; token: string };
      variation?: string;
    }) => {
      try {
        const params = new URLSearchParams({ platform: "REACT" });
        if (variation) params.set("variation", variation);

        const headers = {
          apiKey,
          userId: userAuth.userId,
          token: userAuth.token,
        };

        const response = await fetch(
          `${BACKEND_URL}/api/v2/entities/${entityId}/campaigns/${questId}?${params.toString()}`,
          { headers },
        );

        const { success, message, data, loginAgain } =
          (await response.json()) as {
            success: boolean;
            message: string;
            data: {
              actions: unknown[];
            };
            loginAgain?: boolean;
          };

        if (loginAgain) {
          cookies.remove("externalUserId");
          cookies.remove("questUserId");
          cookies.remove("questUserToken");

          await getUserAuth({
            apiKey: ApiKey,
            entityId: EntityId,
            uniqueUserId,
            uniqueEmailId,
          });
        } else if (success) {
          const actions = data.actions || [];
          setTotalActions(actions.length);
          const completedActionsCount = actions.filter(
            (action: unknown) =>
              action &&
              typeof action === "object" &&
              "isCompleted" in action &&
              !!action.isCompleted,
          ).length;
          setCompletedActions(completedActionsCount);
          setIsAllActionsCompleted(completedActionsCount === actions.length);
        } else {
          throw new Error(message || "Failed to fetch campaign data");
        }
      } catch (error) {
        console.error("Error in fetchCampaignsData:", error);
      }
    },
    [ApiKey, EntityId, cookies, getUserAuth, uniqueEmailId, uniqueUserId],
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userAuth = await getUserAuth({
          apiKey: ApiKey,
          entityId: EntityId,
          uniqueUserId,
          uniqueEmailId,
        });

        if (userAuth?.token && userAuth?.userId) {
          await fetchCampaignsData({
            entityId: EntityId,
            questId: QuestId,
            apiKey: ApiKey,
            userAuth,
          });
        }
      } catch (error) {
        console.error("Error in fetchData:", error);
      }
    };

    void fetchData();
  }, [
    uniqueUserId,
    uniqueEmailId,
    isGetStartedOpen,
    ApiKey,
    EntityId,
    QuestId,
    cookies,
    fetchCampaignsData,
    getUserAuth,
  ]);

  if (completedActions >= totalActions) {
    return null;
  }

  return (
    <>
      <button
        className={classNames("q-get-started-open-btn", className)}
        onClick={() => setIsGetStartedOpen(!isGetStartedOpen)}
      >
        <div className="q-get-started-open-btn-texts">
          <div className="q-get-started-open-btn-text">
            <p>Getting Started</p>
            <ChevronRight />
          </div>
          <p className="q-get-started-open-btn-actions">
            {completedActions}/{totalActions} goals complete
          </p>
        </div>

        <RadialProgressBar
          currentValue={completedActions}
          maxValue={totalActions}
        />
      </button>

      <Modal
        hideHeader
        isOpen={isGetStartedOpen}
        onClose={() => setIsGetStartedOpen(false)}
        classNames={{
          body: "q-get-started-modal-body",
        }}
      >
        {isAllActionsCompleted ? (
          <div className="q-thanks-popup">
            <div className="q-thanks-popup-icon">
              <TickIcon />
            </div>
            <div className="q-thanks-popup-text">
              <div className="q-thanks-popup-text-cont">
                <p>You&apos;re All Set 🎉</p>
                <p>Your dashboard is ready. Start exploring now!</p>
              </div>
              <button
                className="q-thanks-popup-close-cont-btn"
                onClick={() => setIsGetStartedOpen(false)}
              >
                Go to Dashboard!
              </button>
            </div>
          </div>
        ) : (
          <QuestProvider apiKey={ApiKey} entityId={EntityId} apiType="STAGING">
            <QGetStarted
              uniqueUserId={uniqueUserId}
              questId={QuestId}
              template={2}
              showProgressBar={true}
              showFooter={false}
              Headers={[
                {
                  heading: "Complete all the following steps to get started",
                  subHeading: "",
                },
              ]}
              isProgressNumber
              autoHide={false}
              onLinkTrigger={(link: string) => {
                if (typeof link === "string" && link.startsWith("/")) {
                  setIsGetStartedOpen(false);
                  void navigate(link);
                }
              }}
            />
          </QuestProvider>
        )}
      </Modal>
    </>
  );
};

export default GetStarted;
